import Vue from 'vue';

Vue.prototype.$checkIncompletes = (pFields, pData) => {
  let incompleteFields = [];

  pFields.forEach((field) => {
    if (!pData[field.id]) incompleteFields.push(field.label);
  });

  return incompleteFields.join(", ");
};

Vue.prototype.$storage = (pFile) => {
  return process.env.VUE_APP_API_HOST + `/storage${pFile}`;
};

Vue.prototype.$removeEmptyColumns = (arr) => {
  let data = [...arr];

  if (data.length == 0) return [];

  let itemKeys = Object.keys(data[0]);

  itemKeys.forEach((key, i) => {
    let columnaVacia = true;

    for (let j = 0; j < data.length; j++) {
      const item = data[j];

      if (String(item[key] || "").trim()) {
        columnaVacia = false;
        break;
      }
    }

    if (columnaVacia == false) {
      itemKeys[i] = null;
    }
  });

  itemKeys = itemKeys.filter((item) => item);

  data.forEach((item) => {
    itemKeys.forEach((itemKey) => {
      delete item[itemKey];
    });
  });

  return data;
};

Vue.prototype.$removeItemByObjectProperty = (arr, property, val) => {
  if (Array.isArray(val)) {
    return arr.filter((item) => !val.includes(item[property]));
  }

  return arr.filter((item) => item[property] != val);
};

Vue.prototype.$findItemByObjectProperty = (arr, property, val) => {
  return arr.find((item) => item[property] == val);
};

Vue.prototype.$formatter = (type, val, formatOut = null, formatIn = null) => {
  let tempVal = String(val || "").trim();

  if (type == "date") {
    return tempVal
      ? Vue.prototype.$dayjs(tempVal, formatIn ? formatIn : "YYYY-MM-DD").format(
          formatOut ? formatOut : "DD-MM-YYYY"
        )
      : "";
  } else if (type == "time") {
    return tempVal
      ? Vue.prototype.$dayjs(tempVal, formatIn ? formatIn : "HH:mm:ss").format(
          formatOut ? formatOut : "HH:mm"
        )
      : "";
  }
};

Vue.prototype.$isInsideElement = (pElem, pTarget) => new Promise(resolve => {
  do {
    if (pTarget == pElem) {
      // dentro
      resolve(true);
    }
    pTarget = pTarget.parentNode;
  } while (pTarget);
  // afuera
  resolve(false)
});